import React from "react";
import Slider from "react-slick";
import { GetScreenType } from "@stadium/helpers/device";
import { mobileScreenType } from "@stadium/constants";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const LongBlockWithTextAndImages = ({ doc }) => {
  const { title } = doc?.primary || {};
  const { items = [] } = doc || {};

  const carouselConfig = {
    dots: false,
    autoplay: false,
    slidesToShow: items.length,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };

  return (
    <div className="py-5 py-2xl-5  text-only-slice prismic-slice long-block-with-text-and-images">
      <div className="container container-width snackbox-block">
        {checkContentPresence(title) && (
          <div className="fs-3-5 mobile-fs-22 text-black text-center font-weight-bold long-block-text-slice-title lh-1-2 ">
            {textResolver(title)}
          </div>
        )}
        <div
          className={`${
            GetScreenType() !== mobileScreenType
              ? "d-block m-0 flex-md-nowrap text-center justify-content-center"
              : " text-center"
          } `}
        >
          <Slider {...carouselConfig}>
            {items?.map(
              ({
                link: { url, target } = {},
                link_text,
                bg_color,
                heading,
                sub_heading,
                description,
                image,
                image_icon,
              }) => {
                const style = { backgroundColor: bg_color };
                return (
                  <div
                    className="long-block mx-auto py-4 py-2xl-4 px-2xl-3 px-3 text-center m-2 m-2xl-2"
                    style={style}
                  >
                    {checkContentPresence(heading) && (
                      <div className="sns-h3 text-theme-primary image-gallery-title same-size-title pt-4 pt-2xl-4 ">
                        {textResolver(heading)}
                      </div>
                    )}
                    {checkContentPresence(sub_heading) && (
                      <div className="sns-h5 same-size-title gallery-description-block long-text">
                        {textResolver(sub_heading)}

                        <div className="divider-green" />
                      </div>
                    )}

                    {checkContentPresence(description) && (
                      <div className="mt-3 mt-2xl-3 sns-h5 gallery-description-block long-block-description">
                        {textResolver(description)}
                      </div>
                    )}
                    {url && (
                      <PrismicLinkTag
                        urlText={link_text}
                        url={url}
                        target={target}
                        className="long-block-cta-link text-uppercase font-weight-bold"
                      />
                    )}
                    {image_icon?.url && (
                      <div className="logo-image mt-2 mt-md-0">
                        <PrismicImgix
                          alt={image_icon.alt}
                          src={image_icon.url}
                          className="orders-block-image mx-auto"
                          desktop="840px"
                          mobile="375px"
                          tablet="400px"
                          largeDisplay="2400px"
                        />
                      </div>
                    )}
                    {image?.url && (
                      <div className="product-image">
                        <PrismicImgix
                          alt={image.alt}
                          src={image.url}
                          className="orders-block-image mx-auto"
                          desktop="840px"
                          mobile="375px"
                          tablet="400px"
                          largeDisplay="2400px"
                        />
                      </div>
                    )}
                  </div>
                );
              }
            )}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default LongBlockWithTextAndImages;
